module.exports = __webpack_public_path__ + "img/77.3.TP.3a966067.png";